import axios from 'axios'
import { Notification, Message, Loading } from 'element-ui'
import cache from './cache'
import { HTTP_URI } from '../api/api'
const Base64 = require('js-base64').Base64


// if (window.localStorage.getItem('user')) {
//   var token = JSON.parse(window.localStorage.getItem('user')).token
// }

let loading
// loading开始 方法
function startLoading() {
  // element-ui loading 服务调用方式
  // loading = Loading.service({
  //   customClass: 'loading_icon',
  //   fullscreen: true,
  //   lock: true,
  //   text: 'Loading...',
  //   spinner: 'el-icon-loading', // 自定义图标
  //   background: 'rgba(255, 255, 255, 0.1)',

  // })
}
// loading结束 方法
function endLoading() {
  loading.close()
}

// 定义一个变量，有请求变量加一，收到响应变量减一
let loadingCount = 0
/**
 * 调用一次startLoadingAddCount() 方法 开启Loading 并 loadingCount + 1
 * 调用一次endLoadingSubCount() 方法 loadingCount - 1 直到为0 关闭loading
 */
export function startLoadingAddCount() {
  if (loadingCount === 0) {
    // startLoading()
  }
  loadingCount++
}

export function endLoadingSubCount() {
  loadingCount--
  if (loadingCount === 0) {
    // endLoading()
  }
}
axios.defaults.withCredentials = true
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: HTTP_URI.BASEURL,
  // 超时
  timeout: 30000
})

// Network Error 二次诊断
// E001A:  API 被拦截（原因不明，可能是防火墙/安全规则）
// E001A1: API 被浏览器扩展拦截（检测到广告拦截器/隐私工具）
// E001B:  网络或证书问题（同域静态资源也不可达）
// E001C:  设备离线
// E001D:  系统时间异常导致证书失效
async function diagnoseNetworkError() {
  // 1. 设备离线
  if (!navigator.onLine) {
    return 'E001C'
  }

  // 2. 系统时间异常（偏差超过1天认为异常）
  try {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 5000)
    const resp = await fetch('https://worldtimeapi.org/api/timezone/Etc/UTC', {
      method: 'HEAD',
      cache: 'no-store',
      signal: controller.signal
    })
    clearTimeout(timeoutId)
    const serverDate = new Date(resp.headers.get('date'))
    const localDate = new Date()
    if (Math.abs(serverDate - localDate) > 24 * 60 * 60 * 1000) {
      return 'E001D'
    }
  } catch (e) {
    // 时间检测失败，继续下一步
  }

  // 3. 测试同域静态资源
  try {
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 5000)
    const resp = await fetch('/paperLogo.png?diag=' + Date.now(), {
      method: 'HEAD',
      cache: 'no-store',
      signal: controller.signal
    })
    clearTimeout(timeoutId)
    if (resp.ok) {
      // 静态资源可达，说明网络和证书正常，API 请求被拦截
      // 4. 检测是否为浏览器扩展拦截
      try {
        await fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
          method: 'HEAD',
          mode: 'no-cors',
          cache: 'no-store'
        })
      } catch (e) {
        return 'E001A1'
      }
      return 'E001A'
    }
  } catch (e) {
    // 静态资源也失败，说明是网络或证书/系统时间问题
  }

  return 'E001B'
}

// request拦截器
service.interceptors.request.use(
  config => {
    startLoadingAddCount()

    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false

    const localUser = localStorage.getItem('thesis-token');
    let token = ''
    if(localUser){
      try {
        const localToken = Base64.decode(localUser).split('----');
        // console.log(localToken)
        if (localToken[1]) {
          token = localToken[1].replace(/\d{4}$/, '');
        }
        // console.log(token)
        // console.log( localToken[1])
      } catch (e) {
        console.warn('[request] parse thesis-token failed:', e)
        token = ''
      }
    }
    if (token && !isToken) {
      config.headers['token'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    //
    if (!isRepeatSubmit && config.method === 'post') {
      const datas = config.data
      const data = Object.keys(datas).map(item => {
        if (datas[item] === '' || datas[item] == null) delete datas[item]
      })
      const requestObj = {
        url: config.url,
        data: data,
        time: new Date().getTime()
      }
      const sessionObj = cache.session.getJSON('sessionObj')
      if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
        cache.session.setJSON('sessionObj', requestObj)
      }
    }
    return config
  },
  error => {
    endLoadingSubCount()
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  res => {
    endLoadingSubCount()
    // console.log(res)
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = res.data.messageEn || res.data.msgEn || res.data.message
    if (code === 200 || code === 0 ) {
      return res.data
      
    } else if (code === 2002) {
      Notification.error({
        title: msg,
      })
      localStorage.removeItem('thesis-token');
      localStorage.removeItem('userInfo');
      // window.localStorage.clear()
      setTimeout(() => {
        window.location.href = `/`
      }, 1000)
    } else {
      Notification.error({
        title: msg
      })
      return Promise.reject('error')
    }
  },
  async error => {
    endLoadingSubCount()
    let { message } = error
    const errorStatus = error.response?.status
    // 检查是否为 Cloudflare 返回的 HTTP 错误
    const cfRay = error.response?.headers?.['cf-ray']
    // 错误码表
    let errorType = 'E999'
    if (message === 'Network Error') {
      errorType = 'E001'
    } else if (message.includes('timeout')) {
      errorType = 'E002'
    } else if (message.includes('Request failed with status code') || errorStatus) {
      errorType = cfRay ? 'E003A' : 'E003'
    }
    // 对 Network Error 进行二次诊断，区分 API 被拦截 vs 网络/证书问题
    if (errorType === 'E001') {
      errorType = await diagnoseNetworkError()
    }
    const errorTips = {
      E001A: 'Request blocked. Please disable browser extensions (ad blockers, privacy tools) and try again, or switch network.',
      E001A1: 'Request blocked by browser extension. Please disable ad blockers or privacy tools and try again.',
      E001B: 'Network or certificate issue. Please check your network connection, system time, and try again.',
      E001C: 'Your device is offline. Please check your network connection.',
      E001D: 'Your system time seems incorrect. Please check your device time and try again.',
      E002: 'Request timeout, please try again later.',
      E003: 'Server response error, please try again later.',
      E003A: 'Server security check triggered. Please try again later or contact support.',
      E999: 'Unknown error, please try again later.'
    }
    Message({
      message: `${errorType} ${errorTips[errorType]}`,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default service
